﻿import React from 'react';

const SubmittedAnswer = ({ question, value, ...props }) => {
    const questionText = question.questionText;

    return (
        <div className="dynamicFormSubmittedAnswerContainer">
            <p className="dynamicFormConfirmedQuestion">
                {questionText}
            </p>
            <p className="dynamicFormConfirmedAnswer">
                {value}
            </p>
        </div>
    );
};

export default SubmittedAnswer;
